<template>
  <div class="discuss">
    <div class="discuss-detail">

      <div v-if="limitImg==9" class="user-info">
        <div  v-lazy-container="{ selector: 'img' }" style="height: 0.5rem;">
          <img class="userImg" :data-src="faceUrl" alt="" :data-error="errorImg">
        </div>
        <div class="user-info-right">
          <div class="left"  >

            <div class="nickName_createTime">
              <div style="margin-bottom: 0.1rem;font-size: 0;/*display: flex;align-items: center;*/">
                <p style="display: inline-block;vertical-align: bottom;" class="nickName" v-html="parseSpace(discussItem.nickName && discussItem.nickName.slice(0,15))"></p>
                <svg v-if="discussItem.isTop == 1" class="is-top-style"  viewBox="0 0 2048 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" ><defs></defs><path d="M512 30.117647C246.964706 30.117647 30.117647 246.964706 30.117647 512s216.847059 481.882353 481.882353 481.882353h1024c265.035294 0 481.882353-216.847059 481.882353-481.882353S1801.035294 30.117647 1536 30.117647H512z m0-30.117647h1024c283.105882 0 512 228.894118 512 512s-228.894118 512-512 512H512C228.894118 1024 0 795.105882 0 512S228.894118 0 512 0z"></path><path d="M352.376471 397.552941H632.470588l3.011765-42.164706h-237.929412V219.858824h524.047059v135.529411h-234.917647l-3.011765 42.164706h289.129412v39.152941h-292.141176c-3.011765 15.058824-6.023529 27.105882-9.035295 42.164706h210.82353v319.247059h105.411765v42.164706H340.329412v-42.164706h105.411764V478.870588h174.682353c3.011765-15.058824 6.023529-27.105882 9.035295-42.164706h-274.070589v-39.152941z m141.552941 400.564706h334.305882v-48.188235H493.929412v48.188235z m0-81.317647h334.305882v-45.176471H493.929412v45.176471z m0-78.305882h334.305882v-45.176471H493.929412v45.176471z m0-78.305883h334.305882v-45.17647H493.929412v45.17647z m382.494117-240.941176v-60.235294h-108.423529v60.235294h108.423529z m-156.611764 0v-60.235294h-114.447059v60.235294h114.447059z m-162.635294 0v-60.235294H451.764706v60.235294h105.411765z m783.058823-96.376471h364.42353v51.2h-159.62353c-3.011765 27.105882-6.023529 51.2-9.035294 75.294118h144.564706V692.705882h-51.2v-295.152941h-219.858824V692.705882h-51.2V349.364706h123.482353c3.011765-24.094118 6.023529-51.2 9.035294-75.294118h-153.6V222.870588z m240.941177 472.847059c51.2 39.152941 96.376471 81.317647 132.517647 120.470588l-36.141177 39.152941c-33.129412-39.152941-75.294118-81.317647-129.505882-126.494117l33.129412-33.129412z m-87.341177-256h51.2v129.505882c-3.011765 75.294118-21.082353 138.541176-57.223529 183.717647-36.141176 42.164706-93.364706 75.294118-174.682353 99.388236l-27.105883-45.176471c78.305882-21.082353 129.505882-51.2 162.635295-90.352941 30.117647-39.152941 45.176471-87.341176 45.17647-150.588235v-126.494118zM1165.552941 846.305882H1084.235294l-12.047059-48.188235c27.105882 0 51.2 3.011765 75.294118 3.011765 18.070588 0 27.105882-12.047059 27.105882-30.117647V274.070588h-111.435294V222.870588h252.988235v51.2h-87.341176V783.058824c0 42.164706-21.082353 63.247059-63.247059 63.247058z"></path></svg>
              </div>
              <p class="createTime">
                <span v-text="parseDateTime(discussItem.createTime)" style="margin-right: 10px;"></span>
                <span style="display: inline-block;" v-if="ipSwitch==1 && discussItem.ip" v-text="!discussItem.ipAddress && 'IP：未知' || 'IP：' + discussItem.ipAddress "></span>
              </p>

            </div>
          </div>
          <div class="right">
            <!--          <span>举报</span>-->
            <!--          <span>拉黑</span>-->
            <commentOperation :item="discussItem" :isDetail="limitImg"
                              @detailShowPopover="detailShowPopover"></commentOperation>
          </div>
        </div>
      </div>
      <div v-if="limitImg==3" class="user-info user-info-3">
        <div  v-lazy-container="{ selector: 'img' }" style="height: 0.5rem;">
          <img class="userImg" :data-src="faceUrl" alt="" :data-error="errorImg">
        </div>
        <div class="user-info-right" style="height: 0.5rem;">
          <p class="nickName" v-html="parseSpace(discussItem.nickName && discussItem.nickName.slice(0,15))"></p>
          <svg style="display: block;    line-height: normal;height: auto" v-if="discussItem.isTop == 1" class="is-top-style"  viewBox="0 0 2048 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" ><defs></defs><path d="M512 30.117647C246.964706 30.117647 30.117647 246.964706 30.117647 512s216.847059 481.882353 481.882353 481.882353h1024c265.035294 0 481.882353-216.847059 481.882353-481.882353S1801.035294 30.117647 1536 30.117647H512z m0-30.117647h1024c283.105882 0 512 228.894118 512 512s-228.894118 512-512 512H512C228.894118 1024 0 795.105882 0 512S228.894118 0 512 0z"></path><path d="M352.376471 397.552941H632.470588l3.011765-42.164706h-237.929412V219.858824h524.047059v135.529411h-234.917647l-3.011765 42.164706h289.129412v39.152941h-292.141176c-3.011765 15.058824-6.023529 27.105882-9.035295 42.164706h210.82353v319.247059h105.411765v42.164706H340.329412v-42.164706h105.411764V478.870588h174.682353c3.011765-15.058824 6.023529-27.105882 9.035295-42.164706h-274.070589v-39.152941z m141.552941 400.564706h334.305882v-48.188235H493.929412v48.188235z m0-81.317647h334.305882v-45.176471H493.929412v45.176471z m0-78.305882h334.305882v-45.176471H493.929412v45.176471z m0-78.305883h334.305882v-45.17647H493.929412v45.17647z m382.494117-240.941176v-60.235294h-108.423529v60.235294h108.423529z m-156.611764 0v-60.235294h-114.447059v60.235294h114.447059z m-162.635294 0v-60.235294H451.764706v60.235294h105.411765z m783.058823-96.376471h364.42353v51.2h-159.62353c-3.011765 27.105882-6.023529 51.2-9.035294 75.294118h144.564706V692.705882h-51.2v-295.152941h-219.858824V692.705882h-51.2V349.364706h123.482353c3.011765-24.094118 6.023529-51.2 9.035294-75.294118h-153.6V222.870588z m240.941177 472.847059c51.2 39.152941 96.376471 81.317647 132.517647 120.470588l-36.141177 39.152941c-33.129412-39.152941-75.294118-81.317647-129.505882-126.494117l33.129412-33.129412z m-87.341177-256h51.2v129.505882c-3.011765 75.294118-21.082353 138.541176-57.223529 183.717647-36.141176 42.164706-93.364706 75.294118-174.682353 99.388236l-27.105883-45.176471c78.305882-21.082353 129.505882-51.2 162.635295-90.352941 30.117647-39.152941 45.176471-87.341176 45.17647-150.588235v-126.494118zM1165.552941 846.305882H1084.235294l-12.047059-48.188235c27.105882 0 51.2 3.011765 75.294118 3.011765 18.070588 0 27.105882-12.047059 27.105882-30.117647V274.070588h-111.435294V222.870588h252.988235v51.2h-87.341176V783.058824c0 42.164706-21.082353 63.247059-63.247059 63.247058z"></path></svg>
        </div>
      </div>
      <div v-if="limitImg==3" class="content list-content">
        <a v-if="discussItem.source == 1 && discussItem.aid > 0" :href="articleJumpUrl(25,discussItem.aid)" :style="{'-webkit-line-clamp':(discussItem._picsLength>0? 2 :4)}" v-html="parseSpace(discussItem.content)">
        </a>
        <router-link v-else
                     :to="{name: 'topicColumnDetail', params: { discussID:discussItem.discussID ,topicItem:discussItem }}"
                     :style="{'-webkit-line-clamp':(discussItem._picsLength>0? 2 :4)}" v-html="parseSpace(discussItem.content)">
        </router-link>
      </div>

      <div v-else class="content" v-html="parseSpace(discussItem.content)"
           :style="{'-webkit-line-clamp':(discussItem._picsLength>2? 2 :4)}">
      </div>

      <div class="content content-images clearfix" v-show="discussItem._picsLength>0"
           :class="{'more_two':discussItem._picsLength>1}">
        <img v-for="(item, index) in discussItem.attUrls && discussItem.attUrls.pics" v-if="index<limitImg"
             @click="detailShowSwiper(index)"
             :style="{width:discussItem._picsWidth,height:discussItem._picsHeight}" v-lazy="item.url" alt="">
      </div>
      <div class="content content-video" v-show="discussItem._videosLength>0">
        <video controls :style="{height: discussItem._videosHeight}" playsinline webkit-playsinline
               x5-video-player-type="h5-page"
               :src="discussItem.attUrls && discussItem.attUrls.videos && discussItem.attUrls.videos[0] && discussItem.attUrls.videos[0].url"
               :poster="discussItem.attUrls && discussItem.attUrls.videoPics && discussItem.attUrls.videoPics[0] && discussItem.attUrls.videoPics[0].url" v-bind:controlsList="(isAndroidApp && 'nofullscreen'|| '')"></video>
      </div>
      <div class="members-contribute" v-if="limitImg==3 && discussItem.source == 1 && discussItem.aid > 0">
          <a class="members-contribute-inner" :href="articleJumpUrl(25,discussItem.aid)">
            <img v-if="discussItem.attUrls && discussItem.attUrls.pics && discussItem.attUrls.pics[0] && discussItem.attUrls.pics[0].url" :src="discussItem.attUrls.pics[0].url" alt="">
            <p v-text="parseSpace(discussItem.title)"></p>
          </a>
      </div>
      <div v-if="limitImg==3" class="createTime-comment-operation">
        <p class="createTime">
          <span v-text="parseDateTime(discussItem.createTime)" style="margin-right: 10px;"></span>
          <span style="display: inline-block;" v-if="ipSwitch==1 && discussItem.ip" v-text="!discussItem.ipAddress && 'IP：未知' || 'IP：' + discussItem.ipAddress "></span>
        </p>
        <commentOperation :item="discussItem" :isDetail="limitImg"
                          @detailShowPopover="detailShowPopover"></commentOperation>
      </div>

      <router-link v-if="limitImg==3 && discussItem._picsLength>3 && !(discussItem.source == 1 && discussItem.aid > 0)"
                   :to="{name: 'topicColumnDetail', params: { discussID:discussItem.discussID ,topicItem:discussItem }}">
<!--        <div class="listContent_tip themeColor">更多精彩内容，看详情</div>-->
        <div class="listContent_tip">
            <div class="listContent_tip_inner">
              <span>更多精彩内容，看详情</span>
              <img src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyAgIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjEyOCIgaGVpZ2h0PSIxMjgiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTY3Ni41Nzk1NTYgNTExLjI2MDQ0NGwtMzkwLjI1Nzc3OC0zOTAuMjI5MzMzYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAxIDEgNDAuMjQ4ODg5LTQwLjIyMDQ0Mzk5TDczNi45MTAyMjE5OSA0OTEuMTUwMjIyYTI4LjQ0NDQ0NCAyOC40NDQ0NDQgMCAwIDEgMWUtOCA0MC4yMjA0NDVMMzI2LjU3MDY2NyA5NDEuNzEwMjIyMDFhMjguNDQ0NDQ0IDI4LjQ0NDQ0NCAwIDAgMS00MC4yMjA0NDUtNDAuMjIwNDQ0MDFMNjc2LjU3OTU1NiA1MTEuMjYwNDQ0eiIgIGZpbGw9IiM5OTk5OTkiPjwvcGF0aD48L3N2Zz4=" alt="">
            </div>
        </div>
      </router-link>
    </div>
    <praiseDanner v-if="limitImg===9" :discussItem="discussItem"></praiseDanner>
  </div>
</template>

<script>
  import imgs from '../../tool/imgs'
  import commentOperation from '../comments/commentOperation'
  // import submit from '../../tool/submit'
  import praiseDanner from './praiseDanner'
  import swiper from '../swiper/swiper'
  import utils from '../../tool/utils'

  const _userAgent = window.navigator.userAgent
  const _agent = _userAgent.indexOf('xkyApp') === -1
  export default {
    name: 'discussDetail',
    props: ['discussItem', 'isDetail', 'sid'],
    data () {
      return {
        isShowSwiper: 0,
        faceUrl: this.discussItem && this.discussItem.faceUrl ? this.discussItem.faceUrl : imgs.comment_user_head_icon,
        limitImg: this.isDetail === 1 ? 9 : 3, // 限制图片数量，列表显示 3 张，详情页显示 9 张,
        errorImg: imgs.comment_user_head_icon,
        isAndroidApp: !_agent && /(Android) | (Linux)/gi.test(_userAgent),
        // eslint-disable-next-line no-undef,eqeqeq
        ipSwitch: _ipSwitch == 1 && 1 || 0
      }
    },
    created () {
    },
    mounted () {
    },
    methods: {
      detailShowSwiper: function (index) {
        var _this = this
        _this.$emit('showSwiper', _this.discussItem.attUrls && _this.discussItem.attUrls.pics || '', index)
      },
      detailShowPopover: function () {
        let _this = this
        if (_agent) {
          this.$emit('detailShowPopover')
        } else {
          _this.$router.push({
            name: 'topicColumnDetail',
            params: {discussID: _this.discussItem.discussID, topicItem: _this.discussItem}
          })
        }
      },
      imgEorre: function () {
        console.log('this', this)
        this.src = imgs.comment_user_head_icon
      },
      parseSpace: function (t) {
        return utils.parseSpace(t)
      },
      parseDateTime: function (t) {
        if (!t) return
        return utils.parseDateTime(t)
      },
      articleJumpUrl: function ( articleType, articleID, columnID, linkID) {
        if (!articleType || !articleID) return
        let _this = this
        return utils.articleJumpUrl(_this.sid, articleType, articleID, columnID, linkID)
      }
    },
    components: {
      commentOperation,
      praiseDanner,
      swiper
    },
    destroyed () {
      this.$emit('showSwiper')
    }
  }
</script>

<style scoped>
  .discuss {
    padding: 0.4rem 0.3rem 0.3rem;
  }

  .user-info {
    display: flex;
    //justify-content: space-between;
    //align-items: center;
    //margin-bottom: 0.08rem;
    min-height: 0.6rem;
  }
  .user-info-right{
    display: flex;
    justify-content: space-between;
    width: calc( 100% - 0.66rem);
  }

  .left {
    //display: flex;
  }

   img.userImg {
     float: left;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    margin-right: 0.16rem;
    object-fit: cover;
  }

  .left > div {
    //display: flex;
    //flex-direction: column;
    //flex-flow: column;
    //height: 0.5rem;
    //justify-content: space-between;
  }

  .left .nickName {
    max-width: 4rem;
    font-size: 0.24rem;
    line-height: 0.24rem;
    color: #333333;
    //white-space: nowrap;
    //overflow: hidden;
    //text-overflow: ellipsis;
  }

  .left .createTime {
    font-size: 0.2rem;
    color: #999999;
  }

  .right {
    color: #FF8843;
    font-size: 0.24rem;
  }

  .content {
    font-size: 0.34rem;
    line-height: 0.48rem;
    padding-left: 0.66rem;
    padding-top: 0.2rem;
    color: #000000;
  }

  .content video {
    max-width: 100%;
    width: 100%;
    background: rgba(0, 0, 0, .9);
  }

  .content img {
    max-width: 100%;
    object-fit: cover;
  }

  .more_two img {
    margin-right: 0.12rem;
    margin-bottom: 0.12rem;
    float: left;
  }

  li .list-content, li .list-content a {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
  }

  li .list-content a:active, li .list-content a:visited, li .list-content a:hover, li .list-content a, li .list-content a:link {
    color: #000000;

  }

  .listContent_tip {
    font-size: 0.23rem;
    margin: 0.2rem 0 0.06rem 0;
    //text-align: right;
  }
  svg.is-top-style{
    display: inline-block;
    line-height: 1;
    width: 0.6rem;
    height: 0.25rem;
    fill: var(--themeColor);
    margin-left: 0.1rem;
  }

  .user-info-3{
    align-items: center;
    height: 0.5rem;
  }
  .user-info-3 .user-info-right{
    width: auto;
    align-items: center;
  }
  .createTime-comment-operation{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 0.66rem;
    padding-top: 0.2rem;
    font-size: 0.22rem;
    color: #999999;
    line-height: 0.32rem;
  }

  .listContent_tip_inner{
    width: 3.4rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    background: #F6F6F6;
    border-radius: 0.2rem;
    padding: 0.09rem 0;
    font-size: 0.22rem;
    font-weight: normal;
    color: #666666;
    line-height: 1;

  }
  .listContent_tip_inner>img{
    width: 0.22rem;
    height: 0.18rem;
    margin-left: 0.05rem;
  }

  .members-contribute{
    padding-left: 0.66rem;
    padding-top: 0.2rem;
  }
  .members-contribute-inner{
    display: flex;
    align-items: center;
    height: 0.74rem;
    padding: 0 0.2rem;
    background: #F6F6F6;
    border-radius: 4px;
    font-size: 0.26rem;
    color: #666666;
  }
  .members-contribute-inner>img{
    display: block;
    width: 0.3rem;
    height: 0.3rem;
    margin-right: 0.19rem;
    object-fit: cover;
  }
  .members-contribute-inner>p{
    flex: 1;
    line-height: 0.3rem;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
</style>



// WEBPACK FOOTER //
// discussDetail.vue?a5eabe0a